import { IconSize } from '@icons/types';
import { BorderedInputSizeVariant } from '@primitives/BorderedInput/types';
import { inputSizeToIconSize } from './constants';

export const getSearchIconSize = (size: BorderedInputSizeVariant = 'small'): IconSize => {
    return inputSizeToIconSize[size];
};
